;(function () {
  angular.module('contrast.ip').controller('IPBlacklistCtrl', IPBlacklistCtrl)

  function IPBlacklistCtrl(
    $scope,
    $filter,
    $q,
    $routeSegment,
    $timeout,
    ErrorService,
    IPBlacklistFactory,
    IPBlacklistService,
    SERVER_ENVIRONMENTS
  ) {
    'ngInject'

    var _searchKeywords = '',
      _delay = 300

    var VIEW_NAME = {
      BLACKLIST: 'blacklist',
      WHITELIST: 'whitelist',
      SOURCE_NAMES: 'sourceNames'
    }

    //Variables
    angular.extend($scope, {
      environment: SERVER_ENVIRONMENTS,
      //Data Related Configs/Containers
      data: {
        view: VIEW_NAME.BLACKLIST,
        numPerLoad: 10,
        loadPromise: null,
        busy: true,
        addresses: {
          all: [],
          displayed: [],
          filtered: []
        },
        row: 'name',
        blacklist: !IPBlacklistService.isTrusted(),
        searchKeywords: function (newSearchKeywords) {
          if (!arguments.length) {
            return _searchKeywords
          }

          if (newSearchKeywords !== _searchKeywords) {
            _searchKeywords = newSearchKeywords
          }

          clearAddresses()
          applyFilters()
          loadAddressesForDisplay($scope.data.numPerLoad)

          return _searchKeywords
        }
      }
    })

    //Methods
    angular.extend($scope, {
      loadByScroll: loadByScroll,
      order: order,
      changeEnabled: changeEnabled,
      launchSingleDeleteDialog: launchSingleDeleteDialog,
      isViewBlacklist: isViewBlacklist,
      isViewWhitelist: isViewWhitelist,
      isViewSourceNames: isViewSourceNames
    })

    function launchSingleDeleteDialog(address) {
      IPBlacklistService.openDeleteModal(address).then(init)
    }

    function setViewFromRoute() {
      switch ($routeSegment.name) {
        case 'rules.ip_allowlist':
          setCurrentView(VIEW_NAME.WHITELIST)
          break
        case 'rules.ip':
        case 'rules.ip_denylist':
          setCurrentView(VIEW_NAME.BLACKLIST)
          break
        case 'rules.ip_source_names':
          setCurrentView(VIEW_NAME.SOURCE_NAMES)
          break
        default:
          throw new Error('Unexpected route')
      }
    }

    function init() {
      setViewFromRoute()

      if (isViewBlacklist() || isViewWhitelist()) {
        if (isViewBlacklist()) {
          IPBlacklistService.setTrusted(false)
          $scope.data.blacklist = true
          $scope.data.loadPromise = IPBlacklistFactory.getIPBlacklist()
        } else if (isViewWhitelist()) {
          IPBlacklistService.setTrusted(true)
          $scope.data.blacklist = false
          $scope.data.loadPromise = IPBlacklistFactory.getIPWhitelist()
        }

        $scope.data.busy = true

        $scope.data.loadPromise
          .then(function (response) {
            $scope.data.addresses.all = response.data.addresses
            clearAddresses()
            applyFilters()
          })
          .then(function () {
            return loadAddressesForDisplay($scope.data.numPerLoad)
          })
          .catch(function (response) {
            $scope.data.busy = false
            ErrorService.processError(response)
          })
      }
    }

    function updatingEnvironment(environment, value) {
      if (environment === SERVER_ENVIRONMENTS.DEV.id) {
        $scope.updatingEnabledDev = value
      } else if (environment === SERVER_ENVIRONMENTS.QA.id) {
        $scope.updatingEnabledQA = value
      } else if (environment === SERVER_ENVIRONMENTS.PROD.id) {
        $scope.updatingEnabledProd = value
      }
    }

    function loadAddressesForDisplay(limit) {
      var displayCount =
        $scope.data.addresses.filtered.length < limit
          ? $scope.data.addresses.filtered.length
          : limit
      displayCount = displayCount ? displayCount : 0

      $scope.data.busy = true

      $scope.data.loadPromise = $q(function (resolve) {
        $timeout(function () {
          resolve()
        }, _delay)
      })

      return $scope.data.loadPromise.then(function () {
        $scope.data.addresses.displayed = $scope.data.addresses.filtered.slice(
          0,
          displayCount
        )

        $scope.data.busy = false

        $timeout(function () {
          $scope.$emit('triggerScrollCheck')
        })
      })
    }

    function clearAddresses() {
      $scope.data.addresses.displayed = []
      $scope.data.addresses.filtered = []
    }

    function applyFilters() {
      $scope.data.addresses.filtered = $filter('filter')(
        $scope.data.addresses.all,
        $scope.data.searchKeywords()
      )
      $scope.data.addresses.filtered = $filter('orderBy')(
        $scope.data.addresses.filtered,
        $scope.data.row
      )
    }

    function loadByScroll() {
      var displayedCount = $scope.data.addresses.displayed.length,
        filteredCount = $scope.data.addresses.filtered.length

      if (displayedCount == filteredCount || filteredCount == 0) {
        return
      }

      return loadAddressesForDisplay(displayedCount + $scope.data.numPerLoad)
    }

    function setCurrentView(viewName) {
      $scope.data.view = viewName
    }

    function isViewWhitelist() {
      return $scope.data.view === VIEW_NAME.WHITELIST
    }

    function isViewBlacklist() {
      return $scope.data.view === VIEW_NAME.BLACKLIST
    }

    function isViewSourceNames() {
      return $scope.data.view === VIEW_NAME.SOURCE_NAMES
    }

    function order(rowName) {
      if ($scope.data.row === rowName) {
        return
      }

      $scope.data.row = rowName
      clearAddresses()
      applyFilters()
      return loadAddressesForDisplay($scope.data.numPerLoad)
    }

    function changeEnabled(address, environment) {
      updatingEnvironment(environment, true)
      IPBlacklistFactory.toggleEnabled(address.uuid, environment).then(
        function () {
          updatingEnvironment(environment, false)
        },
        function (response) {
          updatingEnvironment(environment, false)
          ErrorService.processError(response)
        }
      )
    }

    init()
  }
})()
